import type { MortgageRateResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import type { MortgageRateBand } from "web_myplann/Inspiration/Types/MortgageRateBand";
import { mortgageFromPayment } from "web_myplann/Inspiration/Utils/mortgageFromPayment";
import { selectMortgageRateBand } from "web_myplann/Inspiration/Utils/selectMortgageRateBand";

type Args = {
	monthlyPayment: number;
	months: number;
	ltvPercent: number;
};

export const resolveOwnHomeRateBand = (
	rows: MortgageRateResponseDTO[],
	{ monthlyPayment, months, ltvPercent }: Args,
): MortgageRateBand | null => {
	const maturityYears = months / 12;

	const seed = selectMortgageRateBand(rows, {
		ltvPercent,
		maturityYears,
		amount: monthlyPayment * months,
	});
	if (!seed) return null;

	const amount = mortgageFromPayment(monthlyPayment, seed.best / 100, months);

	return (
		selectMortgageRateBand(rows, { ltvPercent, maturityYears, amount }) ?? seed
	);
};
